import Big from "big.js"

export function getRatio(denominator: Big, numerator: Big) {
    if (denominator.eq(0)) {
        return Big(0)
    }
    return numerator.div(denominator)
}
